import { User } from '../Users/Model';
export class Invoice {
    /*payment: Payment[]
    taxes: InvoiceTax[]*/
    constructor(props) {
        this.lines = []; // relación
        Object.assign(this, props);
        this.date = new Date(props.date);
    }
}
export class InvoiceLine {
    constructor(props) {
        Object.assign(this, props);
    }
}
export class CashDesk {
    constructor(props) {
        Object.assign(this, props);
        this.date = new Date(props.date);
    }
}
export const CashDeskState = {
    open: 'open',
    close: 'close',
    partialClose: 'partialClose',
};
export class Ticket {
    constructor(props) {
        this.contact = {
            name: '',
            surname: '',
            telephone: '',
            email: '',
            additionalInformation: '',
        };
        Object.assign(this, props);
        const user = new User(props.user);
        this.user = user;
        this.username = props.username ? props.username : user.username;
        // this.businessUnit = props.operationLine? props.operationLine.businessUnit.name : props.businessUnitName
        this.tin = props.tin ? props.tin : props.operationLine.businessUnit.tin;
        this.image = props.image
            ? props.image
            : props.operationLine
                ? props.operationLine.businessUnit.image
                : undefined;
        // this.operationLine = props.operationLineName !== undefined? props.operationLineName : props.operationLine.name// new OperationLine(props.operationLine)
        // this.stretch = props.stretchName !== undefined? props.stretchName : props.stretch.name // new Stretch(props.stretch)
        this.operationLineName =
            props.operationLineName !== undefined
                ? props.operationLineName
                : props.operationLine.name;
        this.stretchName =
            props.stretchName !== undefined ? props.stretchName : props.stretch.name;
        this.datecheck = new Date(props.datecheck);
        this.datebook = props.datebook ? new Date(props.datebook) : null;
        this.datebookNTZ = props.datebookNTZ ? new Date(props.datebookNTZ) : null;
        this.datevalited = props.datevalited ? new Date(props.datevalited) : null;
        this.daterefund = props.daterefund ? new Date(props.daterefund) : null;
        if (props.lines) {
            if (typeof props.lines !== 'string') {
                this.lines = props.lines.map((line) => new TicketLine(line));
            }
            else {
                this.lines = JSON.parse(props.lines).map((line) => new TicketLine(line));
            }
        }
        if (!props.horasVuelta)
            this.horasVuelta = [];
        if (props.payments)
            this.payments = props.payments.map((payment) => new Payment(payment));
        if (props.ticketRefunded)
            this.ticketRefunded = new Ticket(props.ticketRefunded);
    }
}
export class TicketLine {
    constructor(values) {
        Object.assign(this, values);
        // this.total = (values.price * values.quantity) + ((values.price * values.quantity) * values.tax / 100)
        // console.log('TicketLine - this', this)
    }
}
export class TicketExtraLine {
    constructor(values) {
        this.printDescription = true;
        Object.assign(this, values);
    }
}
export class CollaboratorTicket extends Ticket {
    constructor(props) {
        super(props);
        this.client_id = props.client_id;
        this.collaboratorName = props.collaboratorName;
        this.collaborator_id = props.collaborator_id;
        this.belongCollaboratorPacket = props.belongCollaboratorPacket;
    }
}
export class TicketCashDesk {
    constructor(values) {
        Object.assign(this, values);
        this.dateOpen = new Date(values.dateOpen);
        this.dateClose = new Date(values.dateClose);
    }
}
export class TicketCashDeskLine {
    constructor(values) {
        Object.assign(this, values);
    }
}
export class BasePacketTicket {
    constructor(props) {
        this.hasCollaboratorStretch = false;
        this.collaboratorTickets = [];
        Object.assign(this, props);
        this.datecheck = new Date(props.datecheck);
        this.daterefund =
            props.daterefund === null ? null : new Date(props.daterefund);
        if (props.tickets) {
            this.tickets = props.tickets.map((ticket) => new Ticket(ticket));
        }
        if (props.collaboratorTickets) {
            this.collaboratorTickets = props.collaboratorTickets;
        }
    }
}
export class PacketTicket extends BasePacketTicket {
    constructor(props) {
        super(props);
        Object.assign(this, props);
        /*this.image = props.operationLine.businessUnit.image*/
        if (!props.operationLineName && props.operationLine) {
            this.operationLine =
                props.operationLineName !== undefined
                    ? props.operationLineName
                    : props.operationLine.name; // new OperationLine(props.operationLine)
        }
        /*this.stretch = props.stretchName !== undefined? props.stretchName : props.stretch.name*/ // new Stretch(props.stretch)
        // this.datebook = props.datebook? new Date(props.datebook): null
    }
}
export class Payment {
    constructor(values) {
        Object.assign(this, values);
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/modules/Reports/Model.ts
// module id = 151
// module chunks = 0